module.exports = __webpack_public_path__ + "2-45.jpg?0365aacd475aec36cfd621a03396a322";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-45.jpg
// module id = 122
// module chunks = 0